import { BenefitDTOBenefitEnum } from '../../api';

const benefitPictureImports = import.meta.glob('./img/*.jpg', { query: '?url', import: 'default', eager: true });

export const BENEFIT_PICTURES = Object.fromEntries(
  Object.entries(benefitPictureImports).map(entry => [entry[0].replace(/^.\/img\/(\w+)-picture\.jpg$/, '$1').toUpperCase(), entry[1]]),
) as Record<BenefitDTOBenefitEnum, string>;
